module.exports = __webpack_public_path__ + "img/face9.37ede861.jpg";